const FieldError = (props) => {
    return (
        <div className={`messages ${props.ar ? 'ar' : 'en'}`}>
            <p className="message error"> {props.message} </p>
        </div>
    )
}

export default FieldError